import { ChangeDetectionStrategy, Component, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-payment-electronic-communications-disclosure',
  imports: [BaseModalComponent, MatIconModule, TranslocoDirective],
  templateUrl: './payment-electronic-communications-disclosure.component.html',
  styleUrl: './payment-electronic-communications-disclosure.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PaymentElectronicCommunicationsDisclosureComponent {
  protected readonly isVisible = signal(true);

  readonly closeModal = output<void>();

  protected onClose(): void {
    this.close();
  }

  protected onBack(): void {
    this.close();
  }

  private close(): void {
    this.isVisible.set(false);
    setTimeout(() => {
      this.closeModal.emit();
    }, 200);
  }
}
